import { createFileRoute } from "@tanstack/react-router";
import { guardSelectParts } from "../../../../../utils/workstationGuard";
import { lazy, Suspense } from "react";
import Loading from "../../../../../pages/Loading/Loading";

const SelectParts = lazy(
  () => import("../../../../../pages/SelectParts/SelectParts")
);

export const Route = createFileRoute(
  "/$lang/_authenticated/select-parts/$quantity"
)({
  beforeLoad: guardSelectParts,
  component: () => (
    <Suspense fallback={<Loading />}>
      <SelectParts />
    </Suspense>
  )
});
